import {
  genericGetSingle,
  genericCreateSingle,
  genericDeleteSingle,
  genericGetAll,
  genericUpdateSingle,
} from "../helpers/apiCall";
import { Snapshot } from "../models";
import { Error } from "../types";

/**
 * Get all snapshots
 * @param params URLSearchParams
 * @returns Promise<{ snapshots: Snapshot[] }>
 */
function getAll(
  params: URLSearchParams = null,
): Promise<{ snapshots: Snapshot[] }> {
  return genericGetAll("snapshots", params);
}

/**
 * Get a single snapshot
 * @param id number | string
 * @returns Promise<{ snapshot: Snapshot }>
 */
function getSingle(id: number | string): Promise<{ snapshot: Snapshot }> {
  return genericGetSingle("snapshots", id);
}

/**
 * Create a new snapshot
 * @param snapshot { [key: string]: string | number | boolean | Date | undefined}
 * @returns Promise<{ snapshot: Snapshot } | Error>
 */
function createSingle(snapshot: {
  [key: string]: string | number | boolean | Date | undefined;
}): Promise<{ snapshot: Snapshot } | Error> {
  return genericCreateSingle("snapshots", snapshot);
}

/**
 * Update a single snapshot
 * @param id number | string
 * @param snapshot { [key: string]: string | number | boolean | Date | undefined}
 * @returns Promise<{ snapshot: Snapshot } | Error>
 */
function updateSingle(
  id: number | string,
  snapshot: { [key: string]: string | number | boolean | Date | undefined },
): Promise<{ snapshot: Snapshot } | Error> {
  return genericUpdateSingle("snapshots", id, snapshot);
}

/**
 * Delete a single snapshot
 * @param id number | string
 * @returns Promise<{ deleted: boolean } | { error: string }>
 */
function deleteSingle(
  id: number | string,
): Promise<{ deleted: boolean } | { error: string }> {
  return genericDeleteSingle("snapshots", id);
}

/**
 * Gets the count of snapshots
 * @param params URLSearchParams
 * @returns Promise<{ count: number }>
 */
function getCount(params: URLSearchParams = null): Promise<{ count: number }> {
  params.append("countOnly", "true");
  return genericGetAll("snapshots", params);
}

export const snapshotService = {
  getAll,
  getSingle,
  createSingle,
  updateSingle,
  deleteSingle,
  getCount,
};
